import React, { useState, useEffect } from 'react';
import PaymentByTicket from './PaymentByTicket';
import PaymentByCreditCard from './PaymentByCreditCard';

const FormSubscription = (props) => {
    const {
        companyData,
        values,
        setState,
        onChangeValue,
        handleNext,
        checked,
        planSelected,
        cupom,
    } = props;

    const [disabledbuttom, setDisabledbuttom] = useState(true);
    const [disabledbuttomFormDados, setDisabledbuttomFormDados] = useState(true);
    const [disabledbuttomFormCreditCard, setDisabledbuttomFormCreditCard] = useState(true);
    const [creditCards, setCreditCards] = useState(true);
    const [formValues, setFormValues] = useState([]);
    const [checkbox, setCheckbox] = useState(false);

    useEffect(() => {
        if (!disabledbuttomFormDados && !disabledbuttomFormCreditCard) {
            setDisabledbuttom(false)
        } else {
            setDisabledbuttom(true)
        }
        if (disabledbuttomFormDados) {
            setDisabledbuttom(true)
        } else {
            setDisabledbuttom(false)
        }
    }, [disabledbuttom, disabledbuttomFormDados, disabledbuttomFormCreditCard])

    return (
        <div>
            <PaymentByTicket
                cupom={cupom}
                companyData={companyData}
                values={values}
                setFormValues={setFormValues}
                setState={setState}
                onChangeValue={onChangeValue}
                handleNext={handleNext}
                checked={checked}
                checkbox={checkbox}
                setCheckbox={setCheckbox}
                planSelected={planSelected}
                disabledbuttom={disabledbuttom}
                setDisabledbuttomFormDados={setDisabledbuttomFormDados}
                creditCards={creditCards}
                setCreditCards={setCreditCards}
            />

            {creditCards ?
                <PaymentByCreditCard
                    checked={checked}
                    planSelected={planSelected}
                    creditCards={creditCards}
                    values={values.creditCard}
                    companyData={companyData}
                    formValues={formValues}
                    setState={setState}
                    onChangeValue={onChangeValue}
                    disabledbuttom={disabledbuttom}
                    checkbox={checkbox}
                    setDisabledbuttomFormCreditCard={setDisabledbuttomFormCreditCard}
                /> : ''}
        </div>

    );
}

export default FormSubscription;